import React, { useState, useEffect } from 'react';
import { useSalon } from '../context/SalonContext'; // Import du contexte
// Icônes utilisées
import { FaFacebookSquare, FaInstagram, FaArrowCircleUp, FaPhoneAlt, FaTiktok } from 'react-icons/fa'; // Ajout TikTok si besoin
import './Footer.css';

// Valeurs par défaut (au cas où la BDD est vide ou charge)
const defaultName = "Studio Ambre";
const defaultSlogan = "Votre salon de coiffure mixte.";
const defaultAddress = "46 Av. du Commandant Parisot, 32600 L'Isle-Jourdain";
const defaultPhone = "06 41 30 78 72";
const defaultFb = "https://www.facebook.com/people/Studio-Ambre-Coiffure-Samatan/100093118543312/";
const defaultInsta = "https://www.instagram.com/studio_ambre32?igsh=Nm5ncms0amV0NnBl";

function Footer() {
  const { salonInfos } = useSalon();
  const currentYear = new Date().getFullYear();
  const [showScrollTopButton, setShowScrollTopButton] = useState(false);

  // PWA Install State
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      // Prevent browser default prompt (mini-infobar)
      e.preventDefault();
      // Store event for triggering later
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User response to the install prompt: ${outcome}`);
    setDeferredPrompt(null);
    setIsInstallable(false);
  };

  // Données dynamiques ou par défaut
  const name = salonInfos?.name || defaultName;
  const slogan = "Votre salon de coiffure mixte."; // Slogan non éditable pour l'instant ou partie de info_message ? On garde simple.
  const address = salonInfos?.address || defaultAddress;
  const phone = salonInfos?.phone || defaultPhone;
  const fbLink = salonInfos?.social_facebook || defaultFb;
  const instaLink = salonInfos?.social_instagram || defaultInsta;
  const tiktokLink = salonInfos?.social_tiktok || '';

  const cleanPhone = phone.replace(/\s/g, '').replace(/\./g, '');

  useEffect(() => {
    const checkScrollTop = () => {
      if (window.pageYOffset > 300) {
        setShowScrollTopButton(true);
      } else {
        setShowScrollTopButton(false);
      }
    };
    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, []);

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <footer className="site-footer">
        <div className="container">
          <div className="footer-content-wrapper">

            <div className="footer-column about-column">
              <h4 className="footer-column-title">{name}</h4>
              <p>{slogan}</p>

              {isInstallable && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <button onClick={handleInstallClick} className="btn-install-pwa" style={{ marginTop: 0 }}>
                    📲 Installer l'application
                  </button>
                </div>
              )}
              {salonInfos?.home_service && (
                <p className="footer-home-service">✨ {salonInfos.home_service_text || "Service à domicile disponible"}</p>
              )}
              <div className="social-links">
                {fbLink && (
                  <a href={fbLink} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <FaFacebookSquare />
                  </a>
                )}
                {instaLink && (
                  <a href={instaLink} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <FaInstagram />
                  </a>
                )}
                {tiktokLink && (
                  <a href={tiktokLink} target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                    <FaTiktok />
                  </a>
                )}
              </div>
            </div>

            <div className="footer-column links-column">
              <h4 className="footer-column-title">Navigation</h4>
              <ul className="footer-links-list">
                <li><a href="#hero">Accueil</a></li>
                <li><a href="#about">Le Salon</a></li>
                <li><a href="#services">Nos Services</a></li>
                <li><a href="#gallery">Galerie</a></li>
                <li><a href="#location">Horaires & Accès</a></li>
                <li><a href="#reservation">Réserver</a></li>
              </ul>
            </div>

            <div className="footer-column contact-column">
              <h4 className="footer-column-title">Contact & Accès</h4>
              <p style={{ whiteSpace: 'pre-line' }}>{address}</p>
              <p className="footer-phone">Tél : <a href={`tel:${cleanPhone}`}>{phone}</a></p>
            </div>

          </div>

          <div className="footer-bottom-bar">
            <p>© {currentYear} {name}. Tous droits réservés.</p>
            <p>Site propulsé par <a href="https://www.infocolab.com/" target="_blank" rel="noopener noreferrer" className="sbb-link">infocolab</a></p>
          </div>
        </div>
      </footer>

      <a
        href={`tel:${cleanPhone}`}
        className="fixed-phone-button"
        aria-label={`Appeler ${name}`}
        title={`Appeler ${name}: ${phone}`}
      >
        <FaPhoneAlt className="phone-button-icon" />
        <span className="phone-button-text">{phone}</span>
      </a>

      <button
        onClick={scrollTop}
        className={`scroll-to-top-button ${showScrollTopButton ? 'visible' : ''}`}
        aria-label="Remonter en haut de la page"
        title="Remonter en haut"
      >
        <FaArrowCircleUp />
      </button>
    </>
  );
}

export default Footer;